<template>
  <section id="dashboard">
    <div class="mb-4 card">
      <div class="d-sm-flex justify-content-between p-2 pb-3">
        <h4 class="mb-sm-0 pt-2">
          <a href="/dashboard-teacher">Home</a><span>/</span><span>My Profile</span>
        </h4>
      </div>
    </div>
    <div class="card z-dept-5 shadow p-3">
      <form>
        <div class="row">
          <div class="form-group col-md-12">
            <label>Title</label>
            <input
              type="text"
              ref="title"
              :value="teacherDetails.title"
              class="form-control mb-4"
              placeholder="Title (Mr,Mrs,Miss,Master,Dr...)"
            />
          </div>
          <div class="form-group col-md-6">
            <label>First Name</label>
            <input
              type="text"
              ref="first_name"
              :value="teacherDetails.first_name"
              class="form-control mb-4"
              placeholder="First Name"
            />
          </div>
          <div class="form-group col-md-6">
            <label>Last Name</label>
            <input
              type="text"
              ref="last_name"
              :value="teacherDetails.last_name"
              class="form-control mb-4"
              placeholder="Last Name"
            />
          </div>
          <div class="form-group col-md-6">
            <label>City</label>
            <input
              type="text"
              ref="city"
              :value="teacherDetails.city"
              class="form-control mb-4"
              placeholder="City"
            />
          </div>
          <div class="form-group col-md-6">
            <label>State</label>
            <input
              type="text"
              ref="county"
              :value="teacherDetails.county"
              class="form-control mb-4"
              placeholder="State"
            />
          </div>
          <div class="form-group col-md-6">
            <label>Country</label>
            <input
              type="text"
              ref="country"
              :value="teacherDetails.country"
              class="form-control mb-4"
              placeholder="Country"
            />
          </div>
          <div class="form-group col-md-6">
            <label>Email</label>
            <input
              type="email"
              ref="email"
              :value="teacherDetails.email"
              class="form-control mb-4"
              placeholder="Email"
            />
          </div>
        </div>

        <!-- Sign in button -->
        <button class="btn btn-info btn-block my-4" @click.prevent="updateTeacher()">
          Update Profile
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "Dashboard",
  components: {},
  data() {
    return {
      totalStudents: "",
      totalTeachers: "",
      totalLevels: "",
      fastTeacherToken: localStorage.getItem("fastTeacherToken"),
      fastTeacherId: localStorage.getItem("fastTeacherId"),
      teacherDetails: [],
    };
  },
  methods: {
    updateTeacher() {
      if (
        this.$refs.first_name.value == "" ||
        this.$refs.last_name.value == "" ||
        this.$refs.city.value == "" ||
        this.$refs.county.value == "" ||
        this.$refs.country.value == "" ||
        this.$refs.email.value == ""
      ) {
        this.$toast.open({
          message: "ERROR : All Fields Are Required",
          type: "error",
        });
      } else {
        let data = {
          first_name: this.$refs.first_name.value,
          last_name: this.$refs.last_name.value,
          city: this.$refs.city.value,
          county: this.$refs.county.value,
          country: this.$refs.country.value,
          email: this.$refs.email.value,
          title: this.$refs.title.value,
        };
        const config = {
          headers: {
            Authorization: "Bearer " + this.fastTeacherToken,
            "Content-Type": "application/json",
          },
        };
        this.$toast.open({
          message: "Processing : Updating Please Wait...",
          type: "info",
        });
        axios
          .post(this.$apiURI + "/account/update", data, config)

          .then((response) => {
            if (response.data.error) {
              this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
              });
            } else {
              this.$toast.open({
                message: "Profile Updated Successfully",
                type: "success",
              });
            }
          })
          .catch((error) => {
            this.$toast.open({
              message: "Error : " + error.response.data.message,
              type: "error",
            });
          });
      }
    },
  },

  mounted() {
    this.$toast.open({
      message: "Processing : Loading Dashboard Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastTeacherToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.teacherDetails = response.data.data;
          let teacherName =
            response.data.data.title +
            "" +
            response.data.data.first_name +
            " " +
            response.data.data.last_name;
          localStorage.setItem("teacherName", teacherName);
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.cascading-admin-card {
  margin: 20px 0;
  background: #1c2331 !important;
}

.btn:hover {
  color: #fff;
}

.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .fas,
.cascading-admin-card .admin-up .far {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 13px 0 rgba(0, 0, 0, 0.19);
  padding: 1rem;
  font-size: 1rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}

.admin-up .data p {
  color: #999999;
  font-size: 12px;
}

.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}

.classic-admin-card .card-body p {
  font-size: 13px;
  opacity: 0.7;
  margin-bottom: 0;
}

.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>
